import convertS3ToCloudFront, {
  prepareInventoryImageFetchUrl,
} from "./convertS3ToCloudFront";

function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === "string" && reader.result.length > 0) {
        resolve(reader.result);
        return;
      }
      reject(new Error("FileReader returned empty result"));
    };
    reader.onerror = () => reject(new Error("FileReader failed"));
    reader.readAsDataURL(blob);
  });
}

async function fetchUrlAsBase64(url) {
  const response = await fetch(url, { mode: "cors", cache: "no-cache" });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const blob = await response.blob();
  if (!blob.size) {
    throw new Error("Empty image response");
  }

  return blobToDataUrl(blob);
}

async function fetchRemoteImageAsBase64(url) {
  const s3Url = prepareInventoryImageFetchUrl(url);

  try {
    return await fetchUrlAsBase64(s3Url);
  } catch (s3Error) {
    const cloudFrontUrl = prepareInventoryImageFetchUrl(
      convertS3ToCloudFront(url)
    );
    if (cloudFrontUrl === s3Url) {
      throw s3Error;
    }
    console.warn(`S3 fetch failed, trying CloudFront: ${s3Url}`, s3Error);
    return fetchUrlAsBase64(cloudFrontUrl);
  }
}

async function fetchImageAsBase64(url) {
  if (!url || typeof url !== "string") {
    throw new Error("Invalid image URL");
  }

  const trimmedUrl = url.trim();
  if (!trimmedUrl) {
    throw new Error("Invalid image URL");
  }

  if (trimmedUrl.startsWith("data:")) {
    return trimmedUrl;
  }

  const isRemoteUrl = /^https?:\/\//i.test(trimmedUrl);
  if (!isRemoteUrl) {
    return fetchUrlAsBase64(trimmedUrl);
  }

  try {
    return await fetchRemoteImageAsBase64(trimmedUrl);
  } catch (error) {
    console.error(`Error fetching image from URL: ${trimmedUrl}`, error);
    throw new Error(`Failed to fetch image: ${trimmedUrl}`);
  }
}

export default fetchImageAsBase64;
